import http from '../_http'

const site = {
  //default
  listSite: (m) => { return http.post(`manager/wmds/site/list`, m); },
  detailSite: (m) => { return http.get(`manager/wmds/site/${m.id}`); },

  //crud
  updateSite: (m) => { return http.put(`manager/wmds/site`, m); },
  deleteSite: (m) => { return http.delete(`manager/wmds/site/${m.id}`); },

  //thumbnail
  thumSite: (m) => { return http.get(`manager/wmds/site/thumbnail/${m.id}`); },

  //info
  infoSite: (m) => { return http.post(`manager/wmds/site/info`, m); },

  //domain
  domainSite: (m) => { return http.get(`manager/wmds/site/domain`, m); },

  //clean
  cleanSite: (m) => { return http.get(`manager/wmds/site/clean`, m); },

  //agree
  agreeSite: (m) => { return http.get(`manager/wmds/site/agree`, m); },
}

export default site

export { site }